import React, { useEffect, useRef } from 'react';

// Componente de efeito Matrix Rain adaptado para a identidade visual AIFT
export default function MatrixRain() {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');

        // Configurar tamanho do canvas
        const resizeCanvas = () => {
            canvas.width = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;
        };
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        // Characters for the Matrix effect (Binary + Quantum Symbols)
        const chars = '01{}[]<>/\\#%!@&*+-:;';
        const fontSize = 14;
        const columns = Math.floor(canvas.width / fontSize);
        const drops = Array(columns).fill(1);

        // Colors based on AIFT identity
        const primaryColor = '#E8DFD5'; // Cream accent
        const fadeColor = 'rgba(10, 10, 10, 0.08)'; // Dark Graphite fade

        let frameCount = 0;
        const fps = 20;
        const fpsInterval = 1000 / fps;
        let lastTimestamp = performance.now();
        let animationFrameId;

        function draw(timestamp) {
            animationFrameId = requestAnimationFrame(draw);

            const elapsed = timestamp - lastTimestamp;

            if (elapsed > fpsInterval) {
                lastTimestamp = timestamp - (elapsed % fpsInterval);

                ctx.fillStyle = fadeColor;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.font = `${fontSize}px monospace`;

                for (let i = 0; i < drops.length; i++) {
                    const char = chars[Math.floor(Math.random() * chars.length)];
                    const x = i * fontSize;
                    const y = drops[i] * fontSize;

                    const rand = Math.random();
                    if (rand > 0.98) {
                        ctx.fillStyle = '#F97316';
                    } else if (rand > 0.95) {
                        ctx.fillStyle = '#81B7E6';
                    } else {
                        const opacity = Math.random() * 0.4 + 0.3;
                        ctx.fillStyle = `rgba(232, 223, 213, ${opacity})`;
                    }

                    ctx.fillText(char, x, y);

                    if (y > canvas.height && Math.random() > 0.975) {
                        drops[i] = 0;
                    }
                    drops[i]++;
                }
            }
        }

        animationFrameId = requestAnimationFrame(draw);

        return () => {
            cancelAnimationFrame(animationFrameId);
            window.removeEventListener('resize', resizeCanvas);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            className="absolute inset-0 w-full h-full"
            style={{ background: '#1A1A1A' }}
        />
    );
}
